export enum TimerStatus {
    started = 'started',
    stopped = 'stopped',
}
